<template>
  <div class="search-items-popular">
    <span class="search-items-popular__name">Часто ищут</span>
    <search-item-popular
      v-for="(item, ind) in items"
      :key="`item-popular-${ind}`"
      :name="item.st"
      class="search-items-popular__item"
      @click.native="onClickHandler(item.st)"
    />
  </div>
</template>

<script>
import SearchItemPopular from './SearchItemPopular.vue';

export default {
  name: 'search-items-popular',

  components: {
    SearchItemPopular,
  },

  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    onClickHandler(name) {
      this.$emit('setQuery', name);
    },
  },
};
</script>

<style scoped lang="scss">
.search-items-popular {
  &__name {
    display: inline-block;
    margin-bottom: 8px;
    padding: 4px 0;
    font-weight: 700;
    font-size: 16px;
    line-height: 18px;
    color: rgba(51, 51, 50, 1)
  }
}
</style>
